var render, staticRenderFns
import script from "./gBar.vue?vue&type=script&lang=js&"
export * from "./gBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1b33446')) {
      api.createRecord('b1b33446', component.options)
    } else {
      api.reload('b1b33446', component.options)
    }
    
  }
}
component.options.__file = "src/components/graph/gBar.vue"
export default component.exports